export const GET_MARKET_CHANGES = "GET_MARKET_CHANGES";
export const GET_MARKET_CHANGES_SUCCESS = "GET_MARKET_CHANGES_SUCCESS";
export const GET_MARKET_CHANGES_ERROR = "GET_MARKET_CHANGES_ERROR";

export const GET_MARKET_CHANGES_EXCEL = "GET_MARKET_CHANGES_EXCEL";
export const GET_MARKET_CHANGES_EXCEL_SUCCESS =
  "GET_MARKET_CHANGES_EXCEL_SUCCESS";
export const GET_MARKET_CHANGES_EXCEL_ERROR = "GET_MARKET_CHANGES_EXCEL_ERROR";

export const GET_FILTER_STOCK_VIN = "GET_FILTER_STOCK_VIN";
export const GET_FILTER_STOCK_VIN_SUCCESS = "GET_FILTER_STOCK_VIN_SUCCESS";
export const GET_FILTER_STOCK_VIN_ERROR = "GET_FILTER_STOCK_VIN_ERROR";

export const GET_FILTER_LAST_LOCATION = "GET_FILTER_LAST_LOCATION";
export const GET_FILTER_LAST_LOCATION_SUCCESS =
  "GET_FILTER_LAST_LOCATION_SUCCESS";
export const GET_FILTER_LAST_LOCATION_ERROR =
  "GET_FILTER_LAST_LOCATION_ERROR";
